<template>
  <div class="flex items-center">
    <img :src="this.getImage()" width="100" height="100">
    {{ params.value }}
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    url () {
      return `/management/user/${this.params.data.userId}`
      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  },
  methods: {
    getImage(){
      if(this.params.data.image) return this.params.data.image;
      return 'https://d14209uukh82fi.cloudfront.net/images/users/30555/original/New_profile.png?1625599535';
    }
    
  }
}
</script>
